import { render, staticRenderFns } from "./CreateToken.vue?vue&type=template&id=70063482&scoped=true"
import script from "./CreateToken.vue?vue&type=script&lang=js"
export * from "./CreateToken.vue?vue&type=script&lang=js"
import style1 from "./CreateToken.vue?vue&type=style&index=1&id=70063482&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70063482",
  null
  
)

export default component.exports